import {
  FilterCheckbox,
  FilterRadio,
  FilterType,
  SoDataTableColumnType,
  SoDataTableHeader,
} from "@/types/components/SoDataTable"

export const syncAccountTableHeaders: SoDataTableHeader[] = [
  {
    title: "Customer Name",
    key: "customerName",
    sortable: false,
  },
  {
    title: "Customer Number",
    key: "customerNumber",
    sortKey: "customer.number",
    sortable: true,
  },
  {
    title: "Account Number",
    key: "number",
    sortable: true,
  },
  {
    title: "Junifer ID",
    key: "juniferId",
    sortable: false,
  },
  {
    title: "Core ID",
    key: "coreId",
    sortable: false,
  },
  {
    title: "Users",
    key: "users",
    fallbackValue: "No users",
    sortable: false,
  },
  {
    title: "Status",
    key: "status",
    type: SoDataTableColumnType.STATUS,
    sortable: false,
  },
  {
    title: "Balance",
    key: "balance",
    sortKey: "last_transaction.accountBalance",
    type: SoDataTableColumnType.MONEY_COLORED,
    sortable: true,
  },
  {
    title: "Auto-Sync",
    key: "autoSyncStatus",
    type: SoDataTableColumnType.STATUS,
    sortable: false,
  },
  {
    title: "Used for QA",
    key: "isQaAccount",
    type: SoDataTableColumnType.ICON,
    sortable: false,
    icon: {
      name: "info",
      tooltip:
        "Accounts marked with a ✔ are reserved for QA testing. Do not use or modify them, as this may break automated QA tests. Accounts with 'automation' in the email address are also marked for QA testing.",
    },
  },
  {
    title: "Created At",
    key: "createdDate",
    sortKey: "createdDttm",
    type: SoDataTableColumnType.DATE_TIME,
    sortable: true,
  },
]

export const SearchTerms = {
  ACCOUNT_NUMBER: "Account Number",
  CUSTOMER_NUMBER: "Customer Number",
  CUSTOMER_NAME: "Customer Name",
  JUNIFER_ID: "Juninfer ID",
  CORE_ID: "Core ID",
  USER_EMAIL: "User Email",
} as const

export type SearchTerm = keyof typeof SearchTerms

export const FilterAccountStatuses = {
  TRANSFERRING: "Transferring",
  ACTIVE: "Active",
  TERMINATING: "Terminating",
  CLOSED: "Closed",
  CANCELLED: "Cancelled",
} as const

export const FilterAccountOptions = {
  AUTO_SYNCED: "Auto-Synced Accounts Only",
} as const

export type FilterAccountStatus = keyof typeof FilterAccountStatuses
export type FilterAccountOption = keyof typeof FilterAccountOptions

export type AccountSyncTableFilters = {
  statuses: FilterRadio<FilterAccountStatus>
  options: FilterCheckbox<FilterAccountOption>
}

export const syncAccountTableFilters: AccountSyncTableFilters = {
  statuses: {
    type: FilterType.RADIO,
    label: "Status",
    options: FilterAccountStatuses,
    value: null,
    expandable: true,
  },
  options: {
    type: FilterType.CHECKBOX,
    label: "Options",
    options: FilterAccountOptions,
    value: [],
    expandable: true,
  },
}
